import { GetUsersResponse, UserType } from '@inplay/models';
import { UserPresentationStrategy } from './userPresentationStrategy.interface';
import {
  OrganizationAdminPresentationStrategy,
  SubOrganizationAdminPresentationStrategy,
  VenueAdminPresentationStrategy,
  VenueManagerPresentationStrategy,
} from './implementations';
import { VenueStaffPresentationStrategy } from './implementations/venueStaffPresentationStrategy';

export class UserPresentationFactory {
  static getPresentationStrategy(
    viewerType: UserType,
    userDetail: GetUsersResponse,
  ): UserPresentationStrategy {
    switch (viewerType) {
      case UserType.ORGANIZATION_ADMIN:
        return new OrganizationAdminPresentationStrategy(userDetail);
      case UserType.SUB_ORGANIZATION_ADMIN:
        return new SubOrganizationAdminPresentationStrategy(userDetail);
      case UserType.VENUE_ADMIN:
        return new VenueAdminPresentationStrategy(userDetail);
      case UserType.VENUE_MANAGER:
        return new VenueManagerPresentationStrategy(userDetail);
      case UserType.VENUE_STAFF:
      case UserType.VENUE_BRANCH_LOGIN:
        return new VenueStaffPresentationStrategy(userDetail);
      default:
        throw new Error(
          `No view strategy defined for user type: ${viewerType}`,
        );
    }
  }
}
